import PostProcessRT from './postProcessRT'
import Rendable from '@/glxp/abstract/rendable'
import Shader from '@/glxp/utils/shader'
import Colors from '../color'

import ShaderManifest from '../entities/shaderManifest'
import DebugController from '@/glxp/debug/debugController'

const VERTICES = [-1, 1, 0, -1, -1, 0, 1, -1, 0, 1, 1, 0]
const INDICES = [0, 1, 2, 0, 2, 3]
const UVS = [
  0, 1,
  0, 0,
  1, 0,
  1, 1
]

class Post extends Rendable {
  constructor (scene) {
    super(scene)
    this.hasNormal = false
    // this.onlyVertices = false
    var shader = new Shader(ShaderManifest['shake-post'])
    this.initProgram(shader.vert, shader.frag)
    this.initBuffer({
      vertices: VERTICES,
      // vertices: this.scaleWithMargin(VERTICES),
      uvs: UVS,
      indices: INDICES
    })
    this.initVao()
    this.createUniforms()

    this.rt = new PostProcessRT(this.scene)

    this.color = { r: Colors[0][0], g: Colors[0][1], b: Colors[0][2] }
    // this.tl = new TimelineMax({paused:true})
    // for (let i = 0; i < Colors.length; i++) {
    //     this.tl.to(this.color, 1, { r: Colors[i][0], g: Colors[i][1], b: Colors[i][2] })
    // }

    this.config = {
      noise_exponent: { value: 4, range: [0, 10] },
      noise_speed: { value: 1, range: [0, 10] }
    }

    DebugController.addConfig(this.config, 'ShakePost')
  }

  createUniforms () {
    this.createUniform('uTexture', 'texture')
    this.createUniform('uColor', 'float3')
    this.createUniform('uRez', 'float2')
    this.createUniform('uMouse', 'float2')
    this.createUniform('uTime')
    this.createUniform('uStep')
    this.createUniform('uShake')
    this.createUniform('uNoiseExponent')
    this.createUniform('uSpeed')
    this.createUniform('uMarginScale')
  }

  scaleWithMargin (vertices) {
    let height = this.scene.height
    let margin = this.scene.marginBottom
    let m = margin / height
    vertices[4] += m * 2
    vertices[7] += m * 2
    return vertices
  }

  applyState () {
    let gl = this.gl
    this.scene.applyDefaultState()
    gl.disable(gl.DEPTH_TEST)
    // gl.disable(gl.BLEND)
  }

  preRender () {
    this.rt.preRender()
  }

  postRender () {
    this.rt.postRender()
  }

  render () {
    let gl = this.gl

    gl.useProgram(this.program)
    gl.bindVertexArray(this.vao)
    this.applyState()

    gl.activeTexture(gl.TEXTURE0)
    this.rt.bind()
    this.bindUniform('uTexture', 0)

    this.bindUniform('uRez', [this.scene.width, this.scene.height])
    this.bindUniform('uMouse', this.scene.cursor)
    this.bindUniform('uTime', this.scene.time)
    this.bindUniform('uStep', this.scene.step)
    this.bindUniform('uShake', this.scene.shakeFactor)
    this.bindUniform('uNoiseExponent', this.config.noise_exponent.value)
    this.bindUniform('uSpeed', this.config.noise_speed.value)

    let height = this.scene.height
    let margin = this.scene.marginBottom
    let m = 1 - (margin / height)
    // this.bindUniform("uMarginScale", m)
    this.bindUniform('uMarginScale', 1)

    // this.tl.progress(Math.max(this.scene.step -.1, 0) * 100)
    // this.bindUniform("uColor", [this.color.r, this.color.g, this.color.b])
    let color = this.scene.step > 0.9 ? [Math.random(), Math.random(), Math.random()] : [this.color.r, this.color.g, this.color.b]
    this.bindUniform('uColor', color)

    gl.drawElements(gl.TRIANGLES, INDICES.length, gl.UNSIGNED_SHORT, 0)
    gl.bindVertexArray(null)
  }
}

export default Post
